/**
 * @fileoverview SSR detection hook using React's useSyncExternalStore to
 * determine if code is running server-side or during hydration.
 */

import * as React from 'react';

/**
 * Empty subscribe function for useSyncExternalStore.
 */
function subscribe(): () => void {
  return () => {};
}

/**
 * Returns false for client-side snapshot.
 */
function getSnapshot(): boolean {
  return false;
}

/**
 * Returns true for server-side snapshot.
 */
function getServerSnapshot(): boolean {
  return true;
}

/**
 * Returns true when server-side rendering, or when hydrating.
 */
export default function useSsr(): boolean {
  return React.useSyncExternalStore<boolean>(subscribe, getSnapshot, getServerSnapshot);
}

